import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { Store } from '../interfaces/store.model';
import { StateService } from '../providers/state.service';

@Injectable({ providedIn: 'root' })
export class StoreStateResolver implements Resolve<Store[]> {
    constructor(private stateSvc: StateService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return of(this.stateSvc.getStore());
    }
}
